import React from 'react'
import './index.scss'

interface IProps {
    name: string
    type: string
}

const TagComponent = (props: IProps) => {
    const { name, type } = props

    return <span className={`tag-component small ${type}`}>{name}</span>
}

export default TagComponent
